<template>
    <v-app>

        <!--{{order_data}}-->

        <!--<v-app-bar app>
            <v-toolbar-title>
                <img src="../src/assets/images/ravensworth_logo_full.png" class="ravensworth-logo" @click="navigate('fulfilment')">
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-menu v-model="notification" :close-on-content-click="true" :nudge-width="150" offset-y class="mx-2">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon >
                        <v-icon large>mdi-bell-ring</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title>So, here's what you missed</v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-action>
                        </v-list-item-action>
                    </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <v-list>
                    <v-list-item>
                        <v-list-item-content @click="navigate('basket')">
                            <v-list-item-title>You have incomplete orders in your basket</v-list-item-title>
                            <v-list-item-subtitle>View your basket to edit or remove items</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="navigate('notifications')">View All Notifications</v-btn>
                </v-card-actions>
            </v-menu>

            <v-menu v-model="account" :close-on-content-click="true" :nudge-width="150" offset-y class="mx-2">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon>
                        <v-icon large >mdi-account</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item>
                        <v-list-item-avatar>
                            <img src="../src/assets/images/small.png" alt="John">
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>Hello, username </v-list-item-title>
                            <v-list-item-subtitle>email address</v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-action>
                        </v-list-item-action>
                    </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <v-list class="">
                    <v-list-item v-for="item in account_items" :key="item.title" link>

                        <v-list-item-content @click="navigate(item.path)">
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                            <v-list-item-subtitle>{{item.subtitle}}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="navigate('account/dashboard')">View My Account Dashboard</v-btn>
                    <v-btn text @click="logout">Logout</v-btn>
                </v-card-actions>
            </v-menu>
        </v-app-bar>-->

        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-main class="">
            <!--<router-view/>-->
            <router-view :myvar="templatingValues" v-if="templatingValues != undefined" />
            <Footer></Footer>
        </v-main>
    </v-app>
</template>
<script>

    import Vue from 'vue';
    import Element from 'element-ui';
    import Footer from './components/instant_marketing_comps/Footer.vue';
    import Router from './router.js';
    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';

    import lang from 'element-ui/lib/locale/lang/en'
    import locale from 'element-ui/lib/locale'

    locale.use(lang)

    Vue.use(Element, locale);

    export default {
        name: 'App',
        mixins: [axios],
        components: {
            Footer
        },
        data() {
            return {
                loading: false,
                group: null,
                account: false,
                menu: false,
                customer: {},
                // branch_code: '',
                notification: false,
                templatingValues: undefined,
                account_items: [
                    {
                        title: 'My Orders',
                        subtitle: 'View, manage and download orders from your order history',
                        //path: 'account/orders'
                        path: 'orders'
                    },
                    {
                        title: 'My Profile',
                        subtitle: 'View and update your profile',
                        path: 'profile',
                    },
                    {
                        title: 'My Templates',
                        subtitle: 'Upload and manage your templates',
                        path: 'templates'
                    }
                ],
                mini: true,
                tab: null,
                query_parameters: [
                    'partnerid',
                    'branchid',
                    'dataref',
                    'fulfilment',
                    'templateid',
                    'pdfref',
                    'auth_token'
                ],
                connection_params: {
                    partner_id : '',
                    branch_id : '',
                    data_ref : '',
                    fulfilment : '',
                    template_id : '',
                    template_ref : ''
                },
                customer: {},
                // order: {
                //     template: '',
                //     query_string: '',
                //     fulfilment: '',
                //     data_ref: '',
                //     template_id: '',
                //     template_ref: '',
                // },
                // session: {
                //     print_preferences: {},
                //     excludes: [],
                //     image_url: '',
                //     address_to: '',
                //     data_provider: '',
                //     quantity: 0,
                //     edit_template: '',
                //     templating_values: '',
                //     state_id: '',
                //     data: ''
                // }
            }
        },
        computed: {
            // customer() {
            //     return this.get_state.customer
            // }
            // order_data() {
            //     console.log('updating order object')
            //     window.sessionStorage.setItem('_order_data', JSON.stringify(this.order_data));
            // },
            // session_data() {
            //     console.log('updating session object')
            //     window.sessionStorage.setItem('_session_data', JSON.stringify(this.session_data));
            // }
        },
        watch: {
            // group() {
            //     this.menu = false
            // },
            // customer() {
            //     return this.get_state.customer
            // },
            // order_data: function() {
            //     console.log('updating order object')
            //     window.sessionStorage.setItem('_order_data', JSON.stringify(this.order_data));
            // },
            // session_data: function() {
            //     console.log('updating session object')
            //     window.sessionStorage.setItem('_session_data', JSON.stringify(this.session_data));
            // }

        },
        // beforeUpdate() {
        //
        //     console.log('updating order object - APP')
        //     window.sessionStorage.setItem('_session_data', JSON.stringify(this.session_data));
        //     window.sessionStorage.setItem('_order_data', JSON.stringify(this.order_data));
        // },
        watch: {
            // order_data() {
            //     console.log('updating order object')
            //     window.sessionStorage.setItem('_order_data', JSON.stringify(this.order_data));
            // },
            // session_data() {
            //     console.log('updating session object')
            //     window.sessionStorage.setItem('_session_data', JSON.stringify(this.session_data));
            // }

            order: {
                handler(order){
                    console.log('updating order object ', this.order)
                    window.sessionStorage.setItem('_order_data', JSON.stringify(order));
                },
                deep: true

            },
            // session() {
            //     console.log('updating session object')
            //     window.sessionStorage.setItem('_session_data', JSON.stringify(this.session));
            // }
        },
        created() {
            console.log('In created method of app.vue')

            // if (document.getElementById("PdfjsScript")) {
            //     var element = document.getElementById("PdfjsScript");
            //     element.parentNode.removeChild(element);
            // }

            // if (!document.getElementById("PdfjsScript")) {
            //     let pdfjsScript = document.createElement('script');
            //     pdfjsScript.setAttribute('src', 'https://mozilla.github.io/pdf.js/build/pdf.js');
            //     pdfjsScript.async = true;
            //     pdfjsScript.id = "PdfjsScript";
            //     document.head.appendChild(pdfjsScript);
            // }

        },
        mounted() {
            console.log('In mounted method of app.vue')

            // this.session_data = {
            //     print_preferences: {},
            //     excludes: [],
            //     image_url: '',
            //     address_to: '',
            //     data_provider: '',
            //     quantity: 0,
            //     edit_template: '',
            //     templating_values: '',
            //     state_id: '',
            //     data: ''
            //
            // };
            //
            // this.order_data = {
            //     template: '',
            //     query_string: '',
            //     fulfilment: '',
            //     data_ref: '',
            //     template_id: '',
            //     template_ref: '',
            // };

            // todo start building both the order objects - transient and the persisted job

            // const connection_params = {
            //     partner_id : '',
            //     branch_id : '',
            //     data_ref : '',
            //     fulfilment : '',
            //     template_id : '',
            //     template_ref : ''
            // };

            if (typeof this.$route.query.partnerid !== 'undefined') {
                this.connection_params.partner_id = this.$route.query.partnerid;
                // sessionStorage.setItem('partnerid', this.$route.query.partnerid);
            }

            if (typeof this.$route.query.branchid !== 'undefined') {
                this.connection_params.branch_id = this.$route.query.branchid;
                // sessionStorage.setItem('branchid', this.$route.query.branchid);
            }

            if (typeof this.$route.query.dataref !== 'undefined') {
                this.connection_params.data_ref = this.$route.query.dataref;
                // this.order.data_ref = this.$route.query.dataref;
            }

            if (typeof this.$route.query.fulfilment !== 'undefined') {
                this.connection_params.fulfilment = this.$route.query.fulfilment;

                // this.order.fulfilment = this.$route.query.fulfilment;
            }

            if (typeof this.$route.query.templateid !== 'undefined') {
                this.connection_params.template_id = this.$route.query.templateid;
                // this.order.template_id = this.$route.query.templateid;
            }

            if (typeof this.$route.query.pdfref !== 'undefined') {
                this.connection_params.template_ref = this.$route.query.pdfref;
                // this.order.template_ref = this.$route.query.pdfref;
            }

            if (this.$route.query.version !== undefined) {
                sessionStorage.setItem('_version', this.$route.query.version);
            }

            window.dispatchEvent(new CustomEvent('version-changed', {
                detail: {
                    storage: sessionStorage.getItem('_version')
                }
            }));

            if (this.$route.query.auth_token !== undefined) {
                sessionStorage.setItem('_auth_token', this.$route.query.auth_token);
            }

            if (this.$route.query.sourcePartner !== undefined) {
                sessionStorage.setItem('_sourcePartner', this.$route.query.sourcePartner);
            }

            if (this.$route.query.partnerRef !== undefined) {
                sessionStorage.setItem('_partnerRef', this.$route.query.partnerRef);
            }

            window.sessionStorage.setItem('_connection_params', JSON.stringify(this.connection_params));

            if (this.connection_params.fulfilment !== '' && this.connection_params.data_ref !== '') {
                this.postConnectionParams();
            } else {
                this.getLoginContext();
            }


            // todo the getLoginContext call from here RIFAT

            // console.log('getting get login context')
            //
            // const endpoint = `${process.env.VUE_APP_TKGATEWAY}/api/services/app/Session/GetCurrentLoginContext`;
            // Axios.get(endpoint, this.returnHeaderUsingToken())
            //     .then(response => {
            //         console.log(response.data);
            //
            //         window.sessionStorage.setItem('customer', JSON.stringify(response.data.result.customer));
            //         window.sessionStorage.setItem('templatingValues', JSON.stringify(response.data.result.templatingValues));
            //         window.sessionStorage.setItem('user', JSON.stringify(response.data.result.user));
            //
            //
            //         if (typeof response.data.result.templatingValues === 'undefined') {
            //             window.sessionStorage.setItem('_redirect', "/fulfilment")
            //             Router.push({
            //                 path: '/profile'
            //             });
            //         } else {
            //
            //             Router.push({
            //                 path: '/fulfilment'
            //             });
            //         }
            //     })
            //     .catch(error => {
            //         console.log(error)
            //         // if (error.response.status === 500) {
            //         // }
            //         event.stopPropagation();
            //     })



        },
        methods: {
            async getLoginContext() {
                console.log('getting get login context')

                this.loading = true;

                const endpoint = `${process.env.VUE_APP_TKGATEWAY}/api/services/app/Session/GetCurrentLoginContext`;
                await Axios.get(endpoint, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response.data);
                        console.log(JSON.stringify(response.data.result));
                        console.log('response.data.result.customer=' + JSON.stringify(response.data.result.customer));

                        if (response.data.result.customer !== undefined) {
                            window.sessionStorage.setItem('customer', JSON.stringify(response.data.result.customer));

                            this.customer = response.data.result.customer;
                            console.log('this.customer.ref=' + this.customer.ref);
                            this.getUserPreferences(this.customer.ref);
                        }

                        console.log('response.data.result.templatingValues=' + response.data.result.templatingValues);


                        if (response.data.result.templatingValues !== undefined) {
                            this.templatingValues = response.data.result.templatingValues;
                            // window.sessionStorage.setItem('templatingValues', JSON.stringify(this.templatingValues));
                        } else {
                            var fullAddress = this.customer.address1;
                            if (this.customer.address2 != '') {
                                fullAddress += ', ' + this.customer.address2;
                            }
                            if (this.customer.address3 != '') {
                                fullAddress += ', ' + this.customer.address3;
                            }
                            fullAddress += ', ' + this.customer.town;
                            if (this.customer.county != '') {
                                fullAddress += ', ' + this.customer.county;
                            }
                            fullAddress += ' ' + this.customer.postcode;

                            this.templatingValues = {
                                "customerRef": this.customer.ref,
                                "organisationId": 0,
                                "varCompany_Logo_1": null,
                                "varCompany_Logo_2": null,
                                "varCompany_Logo_3": null,
                                "varCompany_Logo_4": null,
                                "varCompany_Colour_1": "",
                                "varCompany_Colour_2": "",
                                "varCompany_Colour_3": "",
                                "varUser_Company_Name": this.customer.customerName,
                                "varUser_Company_Brand": this.customer.customerName,
                                "varUser_Branch_Name": this.customer.branchName,
                                "varUser_Email": this.customer.accountsEmail,
                                "varUser_Telephone": "",
                                "varUser_Web_Address": "",
                                "varUser_Address_1": this.customer.address1,
                                "varUser_Address_2": this.customer.address2,
                                "varUser_Address_3": this.customer.address3,
                                "varUser_Town": this.customer.town,
                                "varUser_County": this.customer.county,
                                "varUser_PostCode": this.customer.postcode,
                                "varUser_FullAddress": fullAddress
                            }
                        }

                        window.sessionStorage.setItem('templatingValues',  JSON.stringify(this.templatingValues));

                        if (response.data.result.user !== undefined) {
                            window.sessionStorage.setItem('user', JSON.stringify(response.data.result.user));
                        }

                        this.loading = false;

                        // if (typeof response.data.result.customer === 'undefined') {
                        //     //window.sessionStorage.setItem('_redirect', "/fulfilment")
                        //     //Router.push({
                        //     //    path: '/profile'
                        //     //});
                        //     parent.postMessage('InstantMarketingHome', '*');
                        // } else {
                        //     console.log('this.$route.query.showProfile=' + this.$route.query.showProfile);

                        //     if (this.$route.query.showProfile === undefined) {
                        //         Router.push({
                        //             path: '/fulfilment'
                        //         });
                        //     }
                        // }
                    })
                    .catch(error => {
                        console.log(error)

                        this.loading = false;

                        // if (error.response.status === 500) {
                        // }
                        event.stopPropagation();
                    })
            },
            postConnectionParams() {
                this.loading = true;

                let fulfilment_index = '';

                switch(this.connection_params.fulfilment) {
                    case 'back_to_branch':
                        fulfilment_index = 1;
                        break;
                    case 'direct_marketing':
                        fulfilment_index = 2;
                        break;
                    case 'door_drop':
                        fulfilment_index = 3;
                        break;
                    default:
                        fulfilment_index = 0;
                }

                const start_order = {
                    "userId": "string",
                    "customerReference": "string",
                    "sourcePartner": this.connection_params.partner_id,
                    "branchId": this.connection_params.branch_id,
                    "dataUrl": this.connection_params.data_ref,
                    "dataProvider": "string",
                    "dataCost": 0,
                    "templateId": "string",
                    "imageUrl": "string",
                    "addressTo": "string",
                    "fCode": "string",
                    "productRef": "string",
                    "name": "string",
                    "description": "string",
                    "stockType": "string",
                    "pageWidth": 0,
                    "pageHeight": 0,
                    "actualPageWidth": 0,
                    "actualPageHeight": 0,
                    "pageOrientation": "string",
                    "stockWeight": "string",
                    "lamination": "string",
                    "pageCount": 0,
                    "fulfilmentType": fulfilment_index,
                    "quantity": 0
                }

                const postInitialOrderInfor = `${process.env.VUE_APP_TKGATEWAY}/api/DataOrder`;

                Axios.post(postInitialOrderInfor, start_order, this.returnHeaderUsingToken())
                    .then (response => {
                        console.log(response.data)

                        window.sessionStorage.setItem('_order_id', JSON.stringify(response.data.id));

                        this.loading = false;

                        this.getLoginContext();
                        // window.sessionStorage.setItem('_order', JSON.stringify(response.data));
                    })
                    .catch(error => {
                        console.log(error)

                        this.loading = false;

                        // if (error.response.status === 500) {
                        // }
                        event.stopPropagation();
                    })
            },
            navigate(name) {
                this.menu = false;
                this.account = false;
                this.notification = false;
                Router.push({
                    path: '/' + name
                });
            },
            logout() {

                this.removeSessionStorage();
                // window.sessionStorage.clear()
                this.$store.dispatch("authd", false);
                this.account = false;
                Router.push({
                    path: '/' + name
                });
            },
        }
    };
</script>
